import React, { Component } from 'react';
import Header from "../Header/Header"
import Footer from "../Footer/Footer";
import SignPage from '../Body/SignPage';
import { usingQuizzesAPI } from '../Services/fetchService';
import ModalVideo from 'react-modal-video';

export default class App extends Component {
  constructor() {
    super();
    this.setPage = this.setPage.bind(this);
    this.openModal = this.openModal.bind(this);
    this.state = {
      pageStyle: "form",
      QuizQuestions: [],
      isOpen: false
    }
  }
  componentDidMount() {
    usingQuizzesAPI.getQuestions(data => {
      this.setState({
        QuizQuestions: data
      })
    });
  }
  openModal() {
    this.setState({ isOpen: true })
  }
  setPage(pageStyle) {
    this.setState({
      pageStyle: pageStyle
    })
  }
  render() {
    return (
      <div>
        <Header />
        <div className={`App-bg ${this.state.pageStyle}`}>
          {(() => {
            switch (this.state.pageStyle) {
              case "hidon":
              case "form":
                return (
                  <div>
                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='kWp_2YhPEYo' onClose={() => this.setState({ isOpen: false })} />
                    <div className="trailer-button" onClick={this.openModal}></div>
                    <SignPage
                      QuizQuestions={this.state.QuizQuestions}
                      setPage={this.setPage}
                      openModal={this.openModal} />
                  </div>
                );
            }
          })()}
        </div>
        <Footer />
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/App/App.jsx